import styled from 'styled-components'

export const Container = styled.div``

export const Title = styled.h1`
  font-family: Circular-Std-bold;
`

export const SearchContainer = styled.div`
  max-width: 1280px;
  margin: auto;
`

export const InfoCompany = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;

  @media (max-width: 1320px) {
    margin: 24px 0 0 24px;
  }
`
